// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"G2-z","displaySixCardTiles":"H2-z"};